/* XTYMN audit FIX (P1-001): keep the custom header cart badge in sync after AJAX cart changes.
   The theme re-renders .cart-items / .cart-totals / .side-cart via its own section list but the
   AI-generated header badge is not in that list, so it only updated on a full page render.
   Self-contained: no vendor file is modified. Remove the render line in layout/theme.liquid to roll back. */
(function () {
  "use strict";
  var SEL = '[class*="ai-header-cart-count"]';
  var busy = false, timer = null;

  function paint(n) {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent.trim() !== String(n)) { nodes[i].textContent = String(n); }
      nodes[i].setAttribute("aria-label", n + " item" + (n === 1 ? "" : "s") + " in cart");
    }
  }

  function sync() {
    if (busy) { return; }
    busy = true;
    fetch("/cart.js", { cache: "no-store", credentials: "same-origin", headers: { accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === "number") { paint(c.item_count); } })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function queue() { clearTimeout(timer); timer = setTimeout(sync, 250); }

  function start() {
    if (!document.querySelector(SEL)) { return; }

    /* 1. Any add-to-cart submit or click. */
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute("action") || "")) { queue(); }
    }, true);
    document.addEventListener("click", function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[name="add"], .add-to-cart, .quick-add, .cart-remove, .quantity-button') : null;
      if (t) { queue(); }
    }, true);

    /* 2. Whatever the theme re-renders in the drawer or cart table. */
    var watch = document.querySelector(".side-cart") || document.body;
    if (window.MutationObserver) {
      new MutationObserver(queue).observe(watch, { childList: true, subtree: true, characterData: true });
    }

    /* 3. Correct the server-rendered value on a cached page. */
    queue();
    window.addEventListener("pageshow", queue);
  }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", start); } else { start(); }
}());